import { useEffect, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { FullPageLoader } from "@/components/common";

export default function AuthCallback() {
  const navigate = useNavigate();
  const location = useLocation();
  const { signIn } = useAuth();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const params = new URLSearchParams(location.hash.replace(/^#/, ""));
    const sessionId = params.get("session_id");
    (async () => {
      try {
        const { data } = await api.post("/auth/google/session", { session_id: sessionId });
        signIn(data);
        window.history.replaceState(null, "", window.location.pathname);
        navigate(data.user.company_id ? "/dashboard" : "/workspace", { replace: true });
      } catch (e) {
        toast.error(errMsg(e, "Google sign-in failed"));
        navigate("/login", { replace: true });
      }
    })();
  }, [location.hash, navigate, signIn]);

  return <FullPageLoader />;
}
